// src/index.ts
function createThunkMiddleware(extraArgument) {
  const middleware = _ref => {
    let {
      dispatch,
      getState
    } = _ref;
    return next => action => {
      if (typeof action === "function") {
        return action(dispatch, getState, extraArgument);
      }
      return next(action);
    };
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;
export { thunk, withExtraArgument };